const enExtends = {
    //missing
    "Sequence Flow": "Transform into standard connection",
    "Conditional Flow": "Transform into error connection",
    //override
    "Create Task": "Create stage",
    "Append Task": "Append stage",
    //custom
    "Connect": "Add a connection",
    "Connect conditional": "Add an error connection",
};

export default enExtends;